import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import QuickSearchQuery from '@Pages/QuickSearch/Components/QuickSearchQuery';
import Structure from './FieldType/Structure';
import Advanced from './FieldType/Advanced';
import FieldType from './FieldType/FieldType';

import './QueryletSearchField.scss';

function QueryletSearchField({ subItem, boundOps }) {
  const [fieldArr, setFieldArr] = useState({});

  useEffect(() => {
    setFieldArr(() => ({
      ...subItem,
      dataType: subItem.dataType === 'string' && subItem.childrenCount > 0 ? 'complex' : subItem.dataType,
    }));
  }, [subItem]);

  const renderMessage = (typeField, item) => {
    switch (typeField) {
      case 'numeric':
      case 'string':
      case 'word':
        return <FieldType field={item} key={`item-${item.id}`} type={typeField} node={subItem} boundOps={boundOps} />;
      case 'history':
        return <QuickSearchQuery key={fieldArr.uuid} querylet={subItem} />;
      default:
        return <p>Unknown status.</p>;
    }
  };

  const renderContent = (items) => (
    <div style={{ flex: 3 }} className={subItem.openQuerylet ? 'number-query-search-field' : ''}>
      {fieldArr.dataType === 'complex' && items.map((field) => renderMessage(field.dataType, field))}
      {fieldArr.type === 'structure' && fieldArr.id !== 'wrapper' && <Structure structureType={fieldArr} />}
      {fieldArr.type === 'advanced' && fieldArr.id !== 'wrapper' && <Advanced advancedType={subItem} />}
      {fieldArr.type === 'history' && <QuickSearchQuery querylet={fieldArr} />}
    </div>
  );

  return renderContent(fieldArr.children);
}

QueryletSearchField.propTypes = {
  subItem: PropTypes.object,
  boundOps: PropTypes.object,
};
export default QueryletSearchField;
